var exports = $.extend({}, require('core/search/search'));
var SiteConstants = require('constants/SiteConstants');
var wishlistHelpers = require('core/wishlist/components/helpers');

var toggleRefinementDrawer = status => {
    var $refinementBar = $('.refinement-bar');
    var $modalBackground = $('.modal-background');

    if (status === 'open') {
        var $header = $('header');
        var bannerHeight = $header.find('.header-banner').length ? $header.find('.header-banner').outerHeight() : 0;
        var preNavHeight = $header.find('.pre-nav-header').length ? $header.find('.pre-nav-header').outerHeight() : 0;
        var navHeight = $header.find('.header-nav').length ? $header.find('.header-nav').outerHeight() : 0;
        var headerNavHeight = bannerHeight + preNavHeight + navHeight;
        var scrollTopHeight = $header.offset().top;
        $('html').scrollTop(scrollTopHeight);
        // Following two lines for MS Edge to work
        document.body.scrollTop = scrollTopHeight;
        document.documentElement.scrollTop = scrollTopHeight;
        $('html').addClass('lock-scroll');
        $('body').addClass('mobile-filter-drawer-in');
        $refinementBar.addClass('in').css('top', headerNavHeight).siblings().attr('aria-hidden', true);
        $modalBackground.fadeIn(SiteConstants.TransitionSpeed).css('top', headerNavHeight);
        $refinementBar.closest('.row').siblings().attr('aria-hidden', true);
        $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', true);
        $refinementBar.find('.close').focus();
    } else {
        $('html').removeClass('lock-scroll');
        $('body').removeClass('mobile-filter-drawer-in');
        $refinementBar.removeClass('in').siblings().attr('aria-hidden', false);
        $modalBackground.fadeOut(SiteConstants.TransitionSpeed);
        $refinementBar.closest('.row').siblings().attr('aria-hidden', false);
        $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', false);
        $('.btn.filter-results').focus();
    }
};

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
 function updateSortOptions(response, promoTileCount) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    var pageSize = Number($tempDom.find('.grid-footer').data('page-size'));

    sortOptions.forEach(option => {
        var pageUrl = new URL(window.location);
        var urlPageSize = pageUrl.searchParams.get('sz') !== null ? Number(pageUrl.searchParams.get('sz')) : null;
        var optionUrl = new URL(option.url);
        var optionPageSize = Number(optionUrl.searchParams.get('sz'));

        // If 'sz' is already defined in URL, but promo tiles aren't already accounted for, decrement sz param
        if (!isNaN(urlPageSize) && urlPageSize !== optionPageSize - pageSize) {
            var updatedPageSize = optionPageSize - promoTileCount;
            optionUrl.searchParams.set('sz', updatedPageSize);
            option.url = optionUrl.toString();
        }

        $('option.' + option.id).val(option.url);
    });
}

var closeOneRefinementsDropdown = (e) => {
    var $oneRefinementsDropdown = $('.horizontal-onedropdown-filter-group');
    if ((!$('.collapse-one-dropdown-filter').is(e.target) && $oneRefinementsDropdown.has(e.target).length === 0)
        || $('.close-one-refinements-dropdown').is(e.target)) {
            $('.collapse-filters-wrapper').slideUp().removeClass('active');
    }
};

exports.showMore = function () {
    var scope = this;
    this.methods.showMoreObserver();

    $('body').on('search:showMore--success search:filter--success search:sort--success', function(){
        scope.methods.showMoreObserver();
    });

    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var showMoreUrl = $(this).data('url');
        var $showMoreButton = $(e.target);

        scope.methods.retrieveMoreItems($showMoreButton, e);

    });
}

exports.applyFilter = function () {
    var $xhr;
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button',
        function (event) {
            var category = $(event.currentTarget).closest('.refinement');

            if (category && category.hasClass('refinement-category')) {
                localStorage.setItem('refinement-category', true);
                return;
            }
            //find new attr on Sort if selected, if not use the default
            var selectedSort = $('select[name="sort-order"]').find('option[selected="selected"]');
            if (selectedSort.data('id') != null) {
                var sortingRule = selectedSort.data('id');
            } else {
                var sortingRule = $('select[name="sort-order"] option:selected').data('id');
            }
            //create a new url with the correct preferences
            if ($(this).data('href').includes('srule')) {
                var refinementUrl = $(this).data('href').replace(/(srule=).*?(&|$)/,'$1' + sortingRule + '$2');
            } else if (!$(this).data('href').includes('srule') && sortingRule != null) {
                var split = $(this).data('href').indexOf('?') !== -1 ? '&' : '?';
                var refinementUrl = $(this).data('href') + split + 'srule=' + sortingRule;
            } else {
                var refinementUrl = $(this).data('href');
            }

            event.preventDefault();
            event.stopPropagation();
            $(this).trigger('search:filter', event);

            // Cancel previous request
            $xhr && $xhr.abort && $xhr.abort();

            $xhr = $.ajax({
                url: refinementUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: refinementUrl
                },
                method: 'GET',
                timeout: 10000,
                beforeSend: function () {
                    $('.product-grid').spinner().start();
                },
                success: function (response) {
                    module.exports.methods.parseResults(response);
                    $('body').trigger('search:filter--success');
                },
                complete: function () {
                    $('.product-grid').spinner().stop();
                }
            });
        });
};


exports.methods.showMoreObserver = function () {
    const scope = this;

    const callback = (entries, observer) => {
        entries.forEach((entry) => {
            if(entry.isIntersecting){
                scope.retrieveMoreItems($(entry.target));
                observer.disconnect();
            }
        })
    }

    let showMoreButton = document.querySelector('.show-more button');
    if(showMoreButton){
        let options = {
            rootMargin: '500px',
            threshold: 0
        }

        let observer = new IntersectionObserver(callback, options);
        observer.observe(showMoreButton);
    }
}

exports.methods.retrieveMoreItems = function ($button, e) {
    const $grid = $button.closest('.product-grid');
    const url = $button.data("url");
    $button.addClass("loading");
    const scope = this;
    $('body').trigger('search:showMore', e);
    $.ajax({
        url: url,
        data: { selectedUrl: url },
        method: 'GET',
        success: function (response) {
            var promoTileCount = $grid.find('[class*="experience-promoTile"]').length;
            $('.grid-footer').replaceWith(response);
            updateSortOptions(response, promoTileCount);
            wishlistHelpers.updateLinkData();
            $('body').trigger('search:showMore--success');
            affirm.ui.refresh();
        },
        error: function () {
        }
    });
}

exports.oneDropdownSlideToggle = function() {
    var oneDropdownFilter = $('.horizontal-onedropdown-filter');
    if (oneDropdownFilter) {
        var menuToggle = $('.horizontal-onedropdown-filter-btn').unbind();
        menuToggle.removeClass('open');

        menuToggle.on('touchstart click', function(e) {
            e.preventDefault();
            $('.collapse-filters-wrapper').toggleClass('active');
            menuToggle.toggleClass('open');
        });
    }
}

exports.closeRefinements = function () {
    $('html').on('click', '.refinement-bar button.close, .mobile-filter-drawer-in .modal-background', () => toggleRefinementDrawer('close'));
    //for horizontal one dropdown menu
    $('html').on('click', (e) => closeOneRefinementsDropdown(e));
}

exports.filter = () => $('html').on('click', 'button.filter-results', () => toggleRefinementDrawer('open'));

exports.resize = () => {
    var windowWidth = $(window).width();

    $(window).resize(() => {
        // iOS fix: make sure window actually resized before triggering resize functions
        if (windowWidth !== $(window).width()) {
            windowWidth = $(window).width();
            toggleRefinementDrawer('close');
            exports.oneDropdownSlideToggle();
        }
    });
};

module.exports = exports;
